import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '@/services/api/apiService';

interface ingredientType {
  ingredientTypeName: string | number | string | undefined;
  id: number;
  name: string;
}

interface ingredientTypeState {
  data: ingredientType[];
  loading: boolean;
  error: string | null | {};
}

interface ApiResponse {
  data: ingredientType[];
}
const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

export const fetchIngredientType = createAsyncThunk('ingredient/fetchType',
  async (_, { rejectWithValue }) => {

    try {
      const response = await apiService.get<ApiResponse>('/get_all_ingredient_type', PORT, MASTERURL)
      return response.data
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  });

export const createIngredientType = createAsyncThunk(
  'ingredient/createIngredientType',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await apiService.post<ApiResponse>('/create_ingredient_type', payload, PORT, MASTERURL);
      return response.data
    }
    catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');

    }
  }
);

export const updateIngredientType = createAsyncThunk(
  'ingredient/updateIngredientType',
  async (payload: { id: number; ingredientTypeName: string }, { rejectWithValue }) => {
    try {
      const response = await apiService.put<ApiResponse>(
        '/update_ingredient_type',
        payload,
        PORT,
        MASTERURL
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : 'An error occurred'
      );
    }
  }
);

export const softDeleteIngredientType: any = createAsyncThunk<
  number,
  number
>(
  "IngredientType/softDeleteIngredientType",
  async (id,) => {
    try {
      const response = await apiService.patch(
        `soft_delete_ingredient_type?id=${id}`,
        {},
        PORT,
        MASTERURL
      );

      return response



    } catch (error: any) {
      return (
        error?.message || "An error occurred while deleting cuisine type"
      );
    }
  }
);



export const ingredientTypeSlice = createSlice({
  name: 'ingredientType',
  initialState: {
    data: [] as ingredientType[],
    loading: false,
    error: null,
  } as ingredientTypeState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIngredientType.pending, (state) => {
        state.loading = true,
          state.error = null;
      })
      .addCase(fetchIngredientType.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchIngredientType.rejected, (state, action) => {
        state.loading = false,
          state.error = action.payload ?? "UnKnow Error"
      })

  },
});

export default ingredientTypeSlice.reducer